import React, { useEffect, useState } from "react";

import webuildimage from "../../assets/webuild.png";
import capabilitiesimage from "../../assets/Capabilities.png";
import extablishedimage from "../../assets/Established.png";
import homeimage from "../../assets/HomeImage.png";

const works = [
    { image: webuildimage, title: "Boiler erection" },
    { image: capabilitiesimage, title: "Pipeline installation" },
    { image: extablishedimage, title: "Valve fitting" },
    { image: homeimage, title: "Structural fabrication" },
];

export const OurWork = () => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1) % works.length);
        }, 3000);

        return () => clearInterval(timer);
    }, []);

    return (
        <section className="w-full bg-white py-14">
            <div className="max-w-7xl mx-auto px-6">

                <div className="mb-10">
                    <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold">
                        Our work
                    </h2>
                    <p className="mt-3 text-gray-600">
                        Boiler erection, pipeline installation, and structural fabrication projects
                    </p>
                </div>

                {/* Image Slider */}
                <div className="relative overflow-hidden rounded-2xl shadow-lg h-[350px] md:h-[520px]">

                    <img
                        key={index}
                        src={works[index].image}
                        alt={works[index].title}
                        className="w-full h-full object-cover transition-opacity duration-700 ease-in-out"
                    />

                    {/* Caption */}
                    <div className="absolute bottom-0 left-0 right-0 bg-primary-500/40 backdrop-blur-xl p-10 text-white text-lg font-semibold">
                        {works[index].title}
                    </div>
                </div>

                {/* Dots */}
                <div className="mt-6 flex justify-center gap-3">
                    {works.map((_, i) => (
                        <span
                            key={i}
                            onClick={() => setIndex(i)}
                            className={`h-3 w-3 rounded-full cursor-pointer transition 
                        ${i === index ? "bg-orange-500" : "bg-gray-300"}`}
                        />
                    ))}
                </div>

            </div>
        </section>
    );
};